import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { APP_VERSIE } from "@/lib/versie";
import { flushAlles } from "@/lib/flushRegistry";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// v17-R1 D4: draait er op de server een nieuwere versie, dan vraagt een smalle balk om te herladen (nooit automatisch).
export const NieuweVersieBalk = () => {
  const [nieuw, setNieuw] = useState(false);
  const [bezig, setBezig] = useState(false);
  useEffect(() => {
    let weg = false;
    const kijk = () => fetch(`${API}/versie`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!weg && d && Number(d.versie) > APP_VERSIE) setNieuw(true); })
      .catch(() => {});   // stil: geen toast, geen balk
    kijk();
    const t = setInterval(kijk, 5 * 60 * 1000);
    const zicht = () => { if (document.visibilityState === "visible") kijk(); };
    document.addEventListener("visibilitychange", zicht);
    return () => { weg = true; clearInterval(t); document.removeEventListener("visibilitychange", zicht); };
  }, []);
  if (!nieuw) return null;
  const herlaad = async () => {
    setBezig(true);
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    await flushAlles();
    window.location.reload();
  };
  return (
    <div data-testid="nieuwe-versie-balk" role="status" className="bg-blue-600 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex flex-wrap items-center gap-3 text-sm">
        <span className="flex-1 min-w-0">Er is een nieuwe versie van de cockpit. Herlaad de app.</span>
        <button type="button" data-testid="nieuwe-versie-herladen" onClick={herlaad} disabled={bezig}
          className="min-h-[44px] inline-flex items-center gap-2 px-4 rounded-md bg-white text-blue-700 font-semibold hover:bg-blue-50 disabled:opacity-60 transition-colors">
          <RefreshCw className={`h-4 w-4 ${bezig ? "animate-spin" : ""}`} />{bezig ? "Opslaan…" : "Herladen"}
        </button>
      </div>
    </div>
  );
};
